module.exports = __webpack_public_path__ + "static/img/oppodcb2.025f3923.png";